import { Box, Divider, styled, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react'
import BookLikeList from '../books/element/BookCard';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { UploadImagePreview } from '../../../../components/upload-image-preview/UploadImagePreview';
import StateComponents from '../../../../components/state-component/StateComponents';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n';

type Props = {
    bill_no?: string;
    customer_name: string;
    bill_date: string | Date | null;
    pay_date: string | Date | null;
    payment_list_data: {
        id_library_head: number;
        library_head_name: string;
        library_type_name: string;
        library_author_by: string;
        file_name: string;
        file_path: string;
        qty: number;
        price: number;
    }[],

    payment_icon_url: string;
    payment_name: string;
    payment_name_en: string;
    payment_no: string;
    payment_type: string;

    onFileChange?: (file_data: File | null) => void;
    payment_file: File | null;
    file_path?: string;
    payment_date: string | Date;
    payment_time: string;
    payment_amount: string;
    onPaymentDateChange?: (date: string) => void;
    onPaymentTimeChange?: (time: string) => void;
    onPaymentAmountChange?: (amount: string) => void;

    is_view_detail?: boolean;
    is_management_borrow?: boolean;
}



const BoxCustom = styled(Box, {
    shouldForwardProp: (prop) => prop !== "noBg",
})<{ noBg?: boolean }>(({ theme, noBg }) => ({
    backgroundColor: noBg ? "transparent" : "#F6F6F6",
    padding: "40px",
    borderRadius: "16px",
    minHeight: "780px",
    border: "2px solid #DDE1EB",
    [theme.breakpoints.down("md")]: {
        padding: "1.2em",
    },
}));



type payment_file_upload_props = {
    payment_date: string | Date;
    payment_time: string;
    payment_amount: string;
    onPaymentDateChange?: (date: string) => void;
    onPaymentTimeChange?: (time: string) => void;
    onPaymentAmountChange?: (amount: string) => void;
    onFileChange?: (file_data: File | null) => void;
    payment_file: File | null;
    is_view_detail?: boolean;
    is_management_borrow?: boolean;
    file_path?: string;
}
const PaymentFileUpload: React.FC<payment_file_upload_props> = ({
    payment_amount,
    payment_date,
    payment_time,
    onPaymentAmountChange,
    onPaymentDateChange,
    onPaymentTimeChange,
    payment_file,
    is_view_detail,
    onFileChange,
    is_management_borrow,
    file_path
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Box className="flex flex-1 justify-center items-center">
                <UploadImagePreview
                    image_file_blob={payment_file}
                    onClear={() => onFileChange?.(null)}
                    height='100%'
                    // no_border
                    image_file_url={file_path}
                    view={!!file_path}
                    disabled={!!file_path}
                    onChange={(file) => {
                        onFileChange?.(file[0]);
                    }}

                />
            </Box>
            <Box className="w-full">
                <StateComponents
                    disabledAllField={is_view_detail || is_management_borrow}
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                        {
                            seq: 1,
                            type: "DATE",
                            gridProps: {
                                xs: 12,
                                xl: 4
                            },
                            fieldProps: {
                                onChange: (e) => onPaymentDateChange?.(e),
                                heading: t("วันที่ชำระเงิน"),
                                value: `${payment_date || ""}`,
                                placeholder: t("ระบุ")
                            }
                        },
                        {
                            seq: 2,
                            type: "TIME_PICKER",
                            gridProps: {
                                xs: 12,
                                xl: 4
                            },
                            fieldProps: {
                                onChange: (e) => onPaymentTimeChange?.(e),
                                heading: t("เวลาชำระเงิน"),
                                value: payment_time,
                                placeholder: t("ระบุ")
                            }
                        },
                        {
                            seq: 3,
                            type: "TEXT-MASK",
                            gridProps: {
                                xs: 12,
                                xl: 4
                            },
                            fieldProps: {
                                mode: "amount",
                                value: payment_amount,
                                onChange: (e) => onPaymentAmountChange?.(e.target.value),
                                heading: t("จำนวนยอดเงิน (บาท)"),
                                placeholder: t("ระบุ")
                            }
                        }
                    ]}
                />
            </Box>
        </>
    )
}

type payment_channel_status_e_library = {
    payment_icon_url: string;
    payment_name: string;
    payment_name_en: string;
    payment_no: string;
    payment_type: string;
}
export const PaymentChannelStatus: React.FC<payment_channel_status_e_library> = ({
    payment_icon_url,
    payment_name,
    payment_name_en,
    payment_no,
    payment_type
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Typography fontWeight={800} variant='h5'>
                {t("ช่องทางการชำระเงิน")}
            </Typography>
            <Box className="flex flex-col justify-start items-center" mt={5}>
                <div>
                    <img className='aspect-1/4 m-auto' src={payment_icon_url} alt={payment_icon_url} />
                </div>
                <div className="w-full grid grid-cols-12 mt-8 gap-5">
                    <span className='col-span-12 md:col-span-6'>
                        <Typography sx={{ color: '#737373' }} variant='h6'>
                            {t("ชื่อบัญชี")}
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6 text-end flex justify-end items-center'>
                        <Typography>
                            {payment_name}
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <Typography sx={{ color: '#737373' }} variant='h6'>
                            Account Name
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6 flex justify-end text-end items-center'>
                        <Typography>
                            {payment_name_en}
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <Typography sx={{ color: '#737373' }} variant='h6'>
                            {t("เลขที่บัญชี")}
                        </Typography>
                        <Typography sx={{ color: '#737373' }} variant='h6'>
                            Account No.
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6 flex justify-end text-end items-center'>
                        <Typography>
                            {payment_no}
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6'>
                        <Typography sx={{ color: '#737373' }} variant='h6'>
                            Account Type
                        </Typography>
                    </span>
                    <span className='col-span-12 md:col-span-6 flex justify-end text-end items-center'>
                        <Typography>
                            {payment_type}
                        </Typography>
                    </span>
                </div>
            </Box>
        </>
    )
}

const PaymentCart: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const base_api = useSelector((state: RootState) => state.api.image_api);
    const {
        customer_name = "-",
        bill_no = "",
        bill_date = "",
        pay_date = "",
        payment_list_data = [],
        payment_amount,
        payment_date,
        payment_icon_url,
        payment_name,
        payment_no,
        payment_file,
        payment_name_en,
        payment_time,
        payment_type,
        is_view_detail,
        onFileChange,
        onPaymentAmountChange,
        onPaymentDateChange,
        onPaymentTimeChange,
        is_management_borrow,
        file_path
    } = props
    return (
        <Box className="grid grid-cols-12 gap-4 md:gap-8">
            <BoxCustom className={clsx("col-span-12 flex flex-col justify-between", {
                'xl:col-span-6 2xl:col-span-8 ': is_management_borrow,
                'xl:col-span-6 2xl:col-span-4 ': !is_management_borrow
            })}>
                <Box className="flex flex-col">
                    <Typography fontWeight={800} variant='h5'>{t("หมายเลขคำสั่งซื้อ")} {bill_no ? `: ${bill_no}` : ""}</Typography>
                    <div className="flex flex-col gap-2">
                        <span className='flex justify-between items-center'>
                            <Typography mt={2} variant='h6'>
                                {t("ชื่อลูกค้า")}
                            </Typography>
                            <Typography variant='h6'>
                                {customer_name}
                            </Typography>
                        </span>
                        <span className='flex justify-between items-center'>
                            <Typography variant='h6'>
                                {t("ออกบิลเมื่อ")}
                            </Typography>
                            <Typography variant='h6'>
                                {bill_date ? moment(bill_date).add(i18n.language === "en" ? 0 : 543, 'year').format("LLLL") : "-"}
                            </Typography>
                        </span>
                        <span className='flex justify-between items-center'>
                            <Typography variant='h6'>
                                {t("กรุณาชำระก่อน")}
                            </Typography>
                            <Typography variant='h6'>
                                {pay_date ? moment(pay_date).add(i18n.language === "en" ? 0 : 543, 'year').format("LLLL") : "-"}
                            </Typography>
                        </span>
                    </div>

                    <Divider sx={{ my: 5, borderStyle: "dashed", borderWidth: 1.5 }} />
                    <Box className="min-h-[500px] max-h-[500px] overflow-auto">
                        <BookLikeList
                            baseApi={base_api}
                            title=''
                            divider={() => <Divider sx={{ my: 5, borderStyle: "dashed", borderWidth: 1.5 }} />}
                            hidden_button={true}
                            dataLike={payment_list_data?.map((list) => {
                                return {
                                    file_name: list?.file_name,
                                    file_path: list?.file_path,
                                    library_head_name: list?.library_head_name,
                                    library_author_by: list?.library_author_by,
                                    id: list?.id_library_head,
                                    other_content: () => (
                                        <Box className="flex justify-between w-full items-center">
                                            <span>{t("จำนวน {{qty}} รายการ", { qty: list?.qty || "-" })}</span>
                                            <span>{list?.price || "-"} {t("บาท")}</span>
                                        </Box>
                                    )
                                }
                            })}
                        />
                    </Box>
                </Box>
                <Box my={4} className="flex flex-wrap flex-col md:flex-row w-full justify-between items-center">
                    <span>
                        <Typography sx={{ xs: 14, xl: "24px" }} fontWeight={600}>
                            {t("ยอดสุทธิ")}
                        </Typography>
                    </span>
                    <span>
                        <Typography sx={{ xs: 14, xl: "24px" }} fontWeight={600}>
                            {payment_list_data?.reduce((x, y) => x + Number(y.price * y?.qty || 0), 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                minimumIntegerDigits: 2
                            })} {t("บาท")}
                        </Typography>
                    </span>
                </Box>

            </BoxCustom >
            <BoxCustom className={clsx("col-span-12 xl:col-span-6 2xl:col-span-4", {
                'hidden': is_management_borrow
            })}>
                {is_view_detail ? (
                    <PaymentFileUpload
                        payment_amount={payment_amount}
                        payment_date={payment_date}
                        payment_file={payment_file}
                        payment_time={payment_time}
                        onFileChange={onFileChange}
                        onPaymentAmountChange={onPaymentAmountChange}
                        onPaymentDateChange={onPaymentDateChange}
                        onPaymentTimeChange={onPaymentTimeChange}
                        is_view_detail={is_view_detail}
                    />
                ) : (
                    <PaymentChannelStatus
                        payment_icon_url={payment_icon_url}
                        payment_name={payment_name}
                        payment_name_en={payment_name_en}
                        payment_no={payment_no}
                        payment_type={payment_type}
                    />
                )}

            </BoxCustom>
            <BoxCustom className="col-span-12 2xl:col-span-4 flex flex-col justify-between items-center">
                <PaymentFileUpload
                    payment_amount={payment_amount}
                    payment_date={payment_date}
                    payment_file={payment_file}
                    payment_time={payment_time}
                    onFileChange={onFileChange}
                    onPaymentAmountChange={onPaymentAmountChange}
                    onPaymentDateChange={onPaymentDateChange}
                    onPaymentTimeChange={onPaymentTimeChange}
                    is_view_detail={is_view_detail}
                    is_management_borrow={is_management_borrow}
                    file_path={file_path}
                />
            </BoxCustom>
        </Box >
    )
}

export default PaymentCart